/**
 * Created by Ning Jiang on 2022-01-14.
 */

import {IdleAnimationController} from "../IdleAnimationController";
import {gsap, TimelineLite} from "gsap";
import {MathHelper} from "../../../core/utils/MathHelper";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DeadwoodRip} from "../../DeadwoodRip";
import {DeadwoodRipLayers, Layers} from "../../view/DeadwoodRipLayers";

export class MainIdleDustController extends IdleAnimationController {

    private _isPlaying:boolean = false;

    private _startDelay:number = 15;
    private _intervalRange:[number, number] = [10, 30];
    private _mainTl:TimelineLite | null;

    constructor() {
        super();
    }

    public start():void {
        if(this._isPlaying) {
            return;
        }

        this._isPlaying = true;
        this._mainTl = new TimelineLite();
        this._mainTl.add(() => this.playAnimation(), this._startDelay);
    }

    public stop():void {
        this._isPlaying = false;
        if(this._mainTl) {
            this._mainTl.pause();
            this._mainTl.kill();
        }
        this._mainTl = null;
    }

    private playAnimation():void {
        if(!this._isPlaying) {
            return;
        }

        this._mainTl = new TimelineLite();
        this._mainTl.add(() => this.playDust());
        this._mainTl.add(() => this.playAnimation(), MathHelper.randomNumberInRange(this._intervalRange[0], this._intervalRange[1], 2));
    }

    private playDust():void {
        if(!NolimitApplication.isLandscape) {
            return;
        }

        const dust = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset("mainIdleDust"));
        dust.autoUpdate = true;
        dust.alpha = 0;
        dust.position.set(360, 360);
        DeadwoodRipLayers.getLayer(Layers.BACKGROUND_IDLE)?.addChild(dust);

        const tl = new TimelineLite();
        tl.add(() => {dust.state.setAnimation(0, "animation", false)});
        tl.add(gsap.to(dust, 0.2, {alpha : 1}));
        tl.add(() => {
            dust.state.setEmptyAnimations(0);
            dust.parent.removeChild(dust);
            dust.destroy();
        }, dust.spineData.findAnimation("animation").duration);
    }
}